/**
 * Apply a TLD to a domain-search input value.
 *
 * - Empty input: uses the default domain name (e.g. "meine-domain") with the TLD.
 * - Input with a TLD: replaces everything after the first dot.
 * - Bare name: appends the TLD.
 */
export function applyTld(current: string, tld: string, defaultName: string): string {
  const trimmed = current.trim()
  if (!trimmed) return `${defaultName}.${tld}`
  if (trimmed.includes('.')) return `${trimmed.substring(0, trimmed.indexOf('.'))}.${tld}`
  return `${trimmed}.${tld}`
}

/**
 * Join a domain's name and TLD into its fully qualified form.
 *
 * The API models a registered domain as name + TLD, while sub-account and
 * mail-only records arrive with the TLD already part of the name, so the TLD
 * is optional. Returns an empty string for a domain that is not loaded yet.
 */
export function domainFqdn(domain?: { name?: string; tld?: string | null } | null): string {
  if (!domain?.name) return ''
  return domain.tld ? `${domain.name}.${domain.tld}` : domain.name
}
